/**
 * Basic event type definitions for Kismet monitoring
 */

// Common event names used throughout the application
export enum SocketEventTypeEnum {
  WEBSITE_VISIT = "website_visit", //websiteVisits in PUO
  PAGE_VIEW = "page_view", //viewedAt in UMPO,
  URL_CHANGE = "url_change", // pagesViewed in PUO, UMPO
  CLICK = "click",
  CONVERSION = "conversion", //conversionsTracked in PUO,UMPO
  CONVERSION_VALUE = "conversion_value", //conversionValueCents in PUO, UMPO
  FORM_SUBMIT = "form_submit",
  OFFER_SAVED = "offer_saved", //offerSaved in  UMPO
  INPUT_CHANGE = "input_change",
  CHATBOT_STATE = "chatbot_state",
  NAVIGATION_CLICK = "navigation_click",
  ILLUSTRATION_CHANGE = "illustration_change",
  SCROLL = "scroll",
  SESSION_LENGTH = "session_length", //sessionLengthSeconds in PUO,UMPO
  METADATA_FETCHED = "metadata_fetched",
  PUO_VIEW = "puo_view", //viewedAt in UMPO
  PUO_CLICK = "puo_click", //clickedAt in UMPO
}
// The minimal required structure for event data
export interface SocketEventData {
  // The metric name used for tracking (e.g., 'websiteVisits', 'pagesViewed')
  metricName: string;

  // The value to record (defaults to 1 if not provided)
  value?: number | Date;

  // Additional properties are allowed
  [key: string]: any;
}
